import { useAuthAppStore } from "@/store/stores/authStore";

export class PermissionService {
  checkPermissionContextUser({ to }) {
    let userStore = useAuthAppStore();
    let userPerms = userStore?.getParsedToken?.perms;

    console.log("to", to);

    if (!userPerms) return false;

    if (to.path === "/purchase-request/add") {
      const isPoCreate = to.query.POC === "true";
      const requiredPermission = isPoCreate
        ? "PurchaseOrder.Add"
        : "PurchaseRequest.Add";
      return this.checkPermissionsForOperations(requiredPermission);
    }

    // Eğer PermissionCode tanımlıysa kontrol et
    if (to.meta.permissionCode) {
      return userPerms.includes(
        `${userStore.getSelectedComplexDescription}.${to.meta.permissionCode}`
      );
    }

    // Eğer PermissionCodes tanımlıysa en az bir yetkinin eşleşip eşleşmediğini kontrol et
    if (to.meta.permissionCodes && to.meta.permissionCodes.length > 0) {
      // return userPerms.some((perm) => to.meta.permissionCodes.includes(`${userStore.getSelectedComplexDescription}.${perm}`) && perm.includes("Read"));
      return to.meta.permissionCodes.some(
        (perm) =>
          userPerms.includes(
            `${userStore.getSelectedComplexDescription}.${perm}`
          ) && perm.includes("Read")
      );
    }

    // Eğer yetki tanımlı değilse true döndür (yetki kontrolü yapılmıyorsa göster)
    return true;
  }

  getPermissions({ to }) {
    let userStore = useAuthAppStore();
    let userPerms = userStore?.getParsedToken?.perms;

    if (!userPerms)
      return { allowEditing: false, allowAdding: false, allowDeleting: false };

    if (to.meta.permissionCode) {
      return {
        allowEditing:
          userPerms.includes(to.meta.permissionCode) &&
          to.meta.permissionCode.includes("Edit"),
        allowAdding:
          userPerms.includes(to.meta.permissionCode) &&
          to.meta.permissionCode.includes("Add"),
        allowDeleting:
          userPerms.includes(to.meta.permissionCode) &&
          to.meta.permissionCode.includes("Delete"),
      };
    }

    // Eğer PermissionCodes tanımlıysa en az bir yetkinin eşleşip eşleşmediğini kontrol et
    if (to.meta.permissionCodes && to.meta.permissionCodes.length > 0) {
      return {
        allowUpdating: to.meta.permissionCodes.some(
          (perm) =>
            userPerms.includes(
              `${userStore.getSelectedComplexDescription}.${perm}`
            ) && perm.includes("Edit")
        ),
        allowAdding: to.meta.permissionCodes.some(
          (perm) =>
            userPerms.includes(
              `${userStore.getSelectedComplexDescription}.${perm}`
            ) && perm.includes("Add")
        ),
        allowDeleting: to.meta.permissionCodes.some(
          (perm) =>
            userPerms.includes(
              `${userStore.getSelectedComplexDescription}.${perm}`
            ) && perm.includes("Delete")
        ),
      };
    }

    return { allowEditing: true, allowAdding: true, allowDeleting: true };
  }

  hasPermissionForParent(item) {
    let userPerms = useAuthAppStore()?.getParsedToken?.perms;
    let complexStore = useAuthAppStore();

    if (!userPerms) return false;

    return item.SubItems?.some((subItem) => {
      if (subItem.PermissionCode) {
        return userPerms.includes(
          `${complexStore.getSelectedComplexDescription}.${subItem.PermissionCode}`
        );
      }

      if (subItem.PermissionCodes && subItem.PermissionCodes.length > 0) {
        return subItem.PermissionCodes.some((code) =>
          userPerms.includes(
            `${complexStore.getSelectedComplexDescription}.${code}`
          )
        );
      }
      return true; // Eğer yetki kontrolü yoksa true döndür
    });
  }

  hasPermissionForSubItems(subItem) {
    let userPerms = useAuthAppStore()?.getParsedToken?.perms;
    let complexStore = useAuthAppStore();

    if (!userPerms) return false;

    // Eğer PermissionCode tanımlıysa kontrol et
    if (subItem.PermissionCode) {
      return userPerms.includes(
        `${complexStore.getSelectedComplexDescription}.${subItem.PermissionCode}`
      );
    }

    // Eğer PermissionCodes tanımlıysa en az bir yetkinin eşleşip eşleşmediğini kontrol et
    if (subItem.PermissionCodes && subItem.PermissionCodes.length > 0) {
      return subItem.PermissionCodes.some((code) =>
        userPerms.includes(
          `${complexStore.getSelectedComplexDescription}.${code}`
        )
      );
    }

    // Eğer yetki tanımlı değilse true döndür (yetki kontrolü yapılmıyorsa göster)
    return true;
  }

  checkPermissionsForOperations(operation) {
    let userStore = useAuthAppStore();
    let userPerms = userStore?.getParsedToken?.perms;

    if (!userPerms) return false;

    if (operation) {
      return userPerms.includes(
        `${userStore.getSelectedComplexDescription}.${operation}`
      );
    }

    // Eğer yetki tanımlı değilse true döndür (yetki kontrolü yapılmıyorsa göster)
    return false;
  }

  checkPermissionByComplexCode(complexCode) {
    let userStore = useAuthAppStore();
    let userPerms = userStore?.getParsedToken?.perms;

    if (!userPerms) return false;

    if (complexCode) {
      return userPerms.includes(
        `Complex.${userStore.getComplexDescriptionByCode(complexCode)}`
      );
    }
  }

  checkPermissionByComplexDescription(complexDescription) {
    let userStore = useAuthAppStore();
    let userPerms = userStore?.getParsedToken?.perms;

    if (!userPerms) return false;

    return userPerms.includes(`Complex.${complexDescription}`);
  }
}
